import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PageHead from "@/components/feature/PageHead";

const COMPANY_NAME = "NetBasis International";

const title = "Soporte técnico";
const heroImage = "https://net-basis.net/Bilder/technical-support-dach-customer-service.webp";
const heroAlt = "Una mano con destornillador usa una interfaz digital para soporte técnico en el mercado DACH.";
const heroClaimLine1 = "¡Servicio al cliente";
const heroClaimLine2 = "con asesoramiento local!";
const benefitsTitle = "Cómo se beneficia de nuestra experiencia en __soporte técnico__:";
const h2Intro = "NetBasis International ofrece, bajo solicitud, un amplio soporte técnico local, lo que permite a nuestros fabricantes socios garantizar una alta disponibilidad de servicio técnico al cliente sobre el terreno. Esto asegura que los clientes se beneficien de inmediato y de forma integral del valor y la utilidad de los productos y soluciones que representamos.";
const p1Text = "Nuestro servicio altamente especializado ayuda a clientes y socios a implementar y utilizar productos y soluciones de manera rápida y sencilla, así como a resolver cualquier problema. Al mismo tiempo, la conexión directa de NetBasis International con nuestros fabricantes socios garantiza una calidad de soporte constantemente alta en toda la región DACH.";
const bottomClaim = "NetBasis International - drive to excellence with excellent drivers !";

const benefits = [
  "Respuesta a preguntas generales sobre la aplicación y utilización de productos y soluciones",
  "Asistencia competente con y respecto a información operativa específica",
  "Provisión fiable de manuales de instalación y configuración",
  "Ayuda profesional para la instalación y configuración sobre el terreno",
  "Soporte local rápido a través de teléfono, correo electrónico e Internet",
  "Análisis preciso de errores y resolución de problemas mediante un mantenimiento remoto moderno",
  "Identificación y verificación de cualquier error y de sus causas subyacentes",
  "Desarrollo de propuestas concretas de resolución para los errores y disfunciones identificados",
  "Mantenimiento profesional de acuerdo con los arreglos correspondientes y Acuerdos de Nivel de Servicio (Service Level Agreements)",
  "Soporte estructurado multi-tier y multi-level para sistemas TIC complejos",
];

export default function SoporteTecnicoEsPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <PageHead
        title="Soporte Técnico | NetBasis International"
        description="Asistencia local confiable de primer y segundo nivel para garantizar una alta satisfacción del cliente en la región DACH."
        ogUrl="https://net-basis.net/es/servicios/desarrollo-de-negocio/soporte-tecnico"
      />
      <Header />

      <main className="flex-1 pt-20 md:pt-24">
        {/* Hero image */}
        <section className="w-full bg-white py-4 md:py-6 lg:py-8">
          <div className="w-full max-w-[1100px] mx-auto">
            <div className="relative w-full h-[320px] md:h-[420px] lg:h-[500px] overflow-hidden">
              <img loading="lazy"
                src={heroImage}
                alt={heroAlt}
                title={title}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

              <div className="absolute inset-0 z-20 flex items-start justify-center pt-[10%] md:pt-[8%] lg:pt-[10%] pointer-events-none">
                <p
                  className="text-3xl md:text-4xl lg:text-5xl font-normal text-white drop-shadow-[0_1px_4px_rgba(0,0,0,0.6)] text-center leading-[1.15] md:leading-[1.5] animate-[technischerSupportTextSlide_12s_ease-in-out_infinite]"
                  style={{ fontFamily: '"Open Sans", sans-serif' }}
                >
                  <span className="block md:inline">{heroClaimLine1}</span>{" "}
                  <span className="block md:inline">{heroClaimLine2}</span>
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Content */}
        <section className="py-6 md:py-8 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto">
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
              {title}
            </h2>

            <h1 className="font-semibold text-foreground-950 leading-relaxed text-sm md:text-base mb-4">
              {h2Intro}
            </h1>

            <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
              <p>{p1Text}</p>
            </div>

            {/* Benefits heading with italic word */}
            <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mt-8 md:mt-10 mb-5 md:mb-7">
              {benefitsTitle.split("__").map((part, i) =>
                i % 2 === 1 ? <em key={i} className="mr-[0.15em]">{part}</em> : part
              )}
            </h2>

            {/* Benefits with checkmarks */}
            <div className="space-y-1.5 md:space-y-2 text-foreground-950 leading-relaxed text-sm md:text-base">
              {benefits.map((benefit, idx) => (
                <div key={idx} className="flex items-start gap-2 md:gap-3">
                  <div className="w-5 h-5 flex-shrink-0 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-primary-600 text-base md:text-lg"></i>
                  </div>
                  <p>{benefit}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Bottom claim */}
        <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
          <div className="max-w-5xl mx-auto text-center">
            <p className="font-heading text-lg md:text-xl font-bold text-primary-600">
              {bottomClaim}
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}